import { render, staticRenderFns } from "./dongjian.vue?vue&type=template&id=be28d9fa&scoped=true&"
import script from "./dongjian.vue?vue&type=script&lang=js&"
export * from "./dongjian.vue?vue&type=script&lang=js&"
import style0 from "./dongjian.vue?vue&type=style&index=0&id=be28d9fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be28d9fa",
  null
  
)

export default component.exports